var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRSupplierDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-supplier-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c0,-11.038 8.962,-20 20,-20Zm6.405,23.901l-0.037,-0.015l-1.478,1.478l0,3.878c0,0.419 0.339,0.758 0.758,0.758c0.418,0 0.757,-0.339 0.757,-0.758c0,0 0,-5.341 0,-5.341Zm-1.325,-5.692l0.037,-0.01c0.094,-0.387 0.444,-0.675 0.859,-0.675c-0,0 2.626,0 2.626,0c0.488,0 0.884,0.397 0.884,0.884c0,0 0,3.283 0,3.283c0,0.126 -0.101,0.228 -0.227,0.228l-1.064,-0.001c-0.029,0 0,0.044 0,0.044l-0.022,-0.022l0,7.302c0,0.419 0.339,0.758 0.758,0.758c0.418,0 0.757,-0.338 0.757,-0.758c0,0 0,-5.581 0,-5.581c0,-0.125 0.102,-0.227 0.228,-0.227c0.599,-0 1.085,-0.486 1.085,-1.086c0,0 0,-3.94 0,-3.94c0,-1.323 -1.075,-2.399 -2.399,-2.399l-2.626,0c-0.839,0 -1.569,0.437 -1.997,1.091l-0.01,0.016l0.181,0.163l0.93,0.93Zm-10.197,-0.01l0.037,0.01l0.93,-0.93l0.181,-0.163l-0.01,-0.016c-0.429,-0.652 -1.159,-1.091 -1.997,-1.091l-2.626,0c-1.326,0 -2.399,1.076 -2.399,2.399l-0,3.94c-0,0.598 0.481,1.086 1.048,1.086c0.125,-0 0.227,0.101 0.228,0.226c-0,-0 0.037,5.583 0.037,5.583c-0,0.419 0.339,0.757 0.757,0.757c0.419,-0 0.758,-0.339 0.758,-0.758c-0,0 -0,-7.323 -0,-7.323l-1.086,-0c-0.126,-0 -0.227,-0.102 -0.227,-0.228l-0,-3.283c-0,-0.487 0.396,-0.884 0.884,-0.884c-0,0 2.626,0 2.626,0c0.415,0 0.765,0.288 0.859,0.675Zm0.227,11.043l-0,-3.878l-1.478,-1.478l-0.037,0.015l-0,5.341c-0,0.42 0.341,0.758 0.757,0.758c0.417,-0 0.758,-0.338 0.758,-0.758Zm10.436,-7.018c0.29,-0.294 0.287,-0.769 -0.032,-1.063l-2.633,-2.633c-0.296,-0.296 -0.775,-0.296 -1.071,0c-0.296,0.296 -0.296,0.774 -0.001,1.07l0.98,0.945c0.067,0.064 0.088,0.163 0.054,0.249c-0.035,0.086 -0.119,0.142 -0.211,0.142c-0,-0 -5.216,-0 -5.216,-0c-0.092,-0 -0.174,-0.055 -0.21,-0.14c-0.035,-0.085 -0.015,-0.183 0.05,-0.248c-0,-0 0.945,-0.945 0.945,-0.945c0.296,-0.296 0.296,-0.776 -0,-1.072c-0.296,-0.296 -0.775,-0.296 -1.072,0l-2.626,2.627c-0.296,0.296 -0.296,0.775 0,1.071l2.627,2.627c0.148,0.149 0.341,0.221 0.537,0.221c0.195,0 0.387,-0.074 0.535,-0.222l0,0c0.296,-0.295 0.296,-0.775 0,-1.071l-0.946,-0.945c-0.065,-0.065 -0.085,-0.163 -0.05,-0.248c0.036,-0.085 0.118,-0.14 0.21,-0.14c0,-0 5.212,-0 5.212,-0c0.092,-0 0.174,0.055 0.21,0.14c0.035,0.085 0.015,0.183 -0.05,0.248c0,0 -0.945,0.945 -0.945,0.945c-0.296,0.296 -0.296,0.775 0,1.072l0,-0c0.15,0.149 0.342,0.221 0.538,0.221c0.196,0 0.388,-0.074 0.536,-0.222l2.629,-2.629Zm1.745,-7.824c1.216,-0 2.2,-0.984 2.2,-2.2c-0,-1.216 -0.984,-2.2 -2.2,-2.2c-1.216,0 -2.2,0.984 -2.2,2.2c-0,1.216 0.983,2.2 2.2,2.2Zm-14.601,-0c1.216,-0 2.2,-0.984 2.2,-2.2c-0,-1.216 -0.983,-2.2 -2.2,-2.2c-1.217,-0 -2.2,0.984 -2.2,2.2c0,1.216 0.984,2.2 2.2,2.2Z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRSupplierDisc);
export default __webpack_public_path__ + "static/media/iconR-supplier-disc.419fe3e266f2a9942befaccbaca4216d.svg";
export { ForwardRef as ReactComponent };